import serverHealth from 'pages/serverHealth'

export default [
  //point of interest
  { path: '/server-health', name: 'serverHealth', component: serverHealth, meta:{permits:['super_admin']}},
]
